import { Backdrop, Button, Fade, Modal, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Animation_Success_animation from "./ServicesOperationComponent/Helper/Animation_Success_animation";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: 24,
  p: 4,
  borderRadius: "16px",
  borderTop: "5px solid #2E7D32",
};

export default function SuccessModal({ open, message, message2, handleClose }) {
  const handleCloseModal = (event) => {
    event.stopPropagation(); // Detiene la propagación del evento
    handleClose(event); // Llama a la función original de cerrar el modal
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleCloseModal}
      closeAfterTransition
      sx={{ borderRadius: "16px" }}
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Animation_Success_animation />

          <Typography
            id="transition-modal-description"
            sx={{
              mt: 2,
              textAlign: "center",
              fontSize: "18px",
              fontWeight: 600,
              color: "#1A202C",
            }}
          >
            {message}
          </Typography>
          <Typography
            id="transition-modal-description2"
            sx={{
              mt: 2,
              textAlign: "center",
              fontSize: "13px",
              fontWeight: 400,
              color: "#718096",
            }}
          >
            {message2}
          </Typography>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            onClick={(e) => handleCloseModal(e)}
            sx={{
              marginTop: "20px",
              backgroundColor: "#002878",
              "&:hover": {
                backgroundColor: "#002878",
              },
              color: "white",
            }}
          >
            Aceptar
          </Button>
        </Box>
      </Fade>
    </Modal>
  );
}
